import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MsalRedirectComponent } from '@azure/msal-angular';
import 'ag-grid-enterprise';
import { CoreModule } from './core.module';
import { ForbiddenComponent } from './shared/components/Forbidden/forbidden.component';
import { AllCommunityModule, CellSelectionModule, ContextMenuModule, MasterDetailModule, ModuleRegistry, NumberEditorModule, PivotModule, RichSelectModule, RowGroupingModule, SetFilterModule, TreeDataModule } from 'ag-grid-enterprise';


ModuleRegistry.registerModules([ AllCommunityModule,ContextMenuModule,MasterDetailModule,RowGroupingModule, PivotModule, TreeDataModule,RichSelectModule,SetFilterModule,CellSelectionModule, NumberEditorModule ]);

@NgModule({
  declarations: [AppComponent, ForbiddenComponent],
  imports: [AppRoutingModule, CoreModule], // CoreModule - Singleton objects (services, components that are loaded only once)
  bootstrap: [ AppComponent],
})
export class AppModule {}
